import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  Result,
  Practice,
  Content,
  Speaker,
  Why,
  Cost,
  Advance
} from "../../../components/LandingTemplates/smart";

const TITLE = 'Онлайн-курс Целеполагание по Smart';
const DESCRIPTION = 'Онлайн-курс Целеполагание по Smart от Advance | Для тех, кто хочет достигать своих целей | Центр образовательных технологий Advance ✅ Уникальные методики обучения ✅ Эффективное запоминание материала ✅ 100% результат';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `'Open Sans', sans-serif` }}>
      <Screen1 widget={<GetCourseWidget hash={'1b3aef7e8cc5f5526170953f2ad51561e62cf45b'} id={'139540'}/>}/>
      <Result/>
      <Practice/>
      <Content/>
      <Speaker/>
      <Why/>
      <Cost widget={<GetCourseWidget hash={'1b3aef7e8cc5f5526170953f2ad51561e62cf45b'} id={'139540'}/>}/>
      <Advance/>
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
